import { Checkbox, Form, Radio } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Claim status select
 * @component
 * @alias CleaningClaimStatusSelect
 * @property {object} form - parent form object
 * @property {object} cleaning - default null
 * @property {function} showClaimFields
 * @property {function} hideClaimFields
 * @returns <Select /> component for selection claim status of a cleaning
 */
const CleaningClaimStatusSelect = ({
  form,
  cleaning = null,
  showClaimFields,
  hideClaimFields,
  required = false,
}) => {
  const { t } = useTranslation();

  const getClaimStatusValue = (currentCleaning) => {
    if (currentCleaning?.is_claim_in_solution) {
      return "in_solution";
    }

    if (currentCleaning?.is_claim_solved) {
      return "solved";
    }

    return "no_claim";
  };

  const [claimStatus, setClaimStatus] = useState(getClaimStatusValue(cleaning));

  useEffect(() => {
    setClaimStatus(getClaimStatusValue(cleaning));
  }, [cleaning]);

  useEffect(() => {
    form.setFieldsValue({
      claim_status: claimStatus,
    });

    if (claimStatus === "in_solution") {
      form.setFieldsValue({
        is_claim_in_solution: true,
        is_claim_solved: false,
      });
      showClaimFields();
    } else if (claimStatus === "solved") {
      form.setFieldsValue({
        is_claim_in_solution: false,
        is_claim_solved: true,
      });
      showClaimFields();
    } else {
      form.setFieldsValue({
        is_claim_in_solution: false,
        is_claim_solved: false,
      });
      hideClaimFields();
    }
  }, [form, claimStatus, showClaimFields, hideClaimFields]);

  return (
    <React.Fragment>
      <Form.Item
        name={"claim_status"}
        initialValue={getClaimStatusValue(cleaning)}
        rules={[
          {
            validator: (_, value) => {
              if (!required || value === "in_solution" || value === "solved") {
                return Promise.resolve();
              }

              return Promise.reject(new Error(t("common.validation.required")));
            },
          },
        ]}
        style={{ marginBottom: 16 }}
      >
        <Radio.Group
          style={{ width: "100%" }}
          onChange={(e) => {
            setClaimStatus(e.target.value);
          }}
          value={claimStatus}
        >
          <Radio.Button value={"no_claim"}>{t("cleanings.noClaim")}</Radio.Button>
          <Radio.Button value={"in_solution"}>
            {t("cleanings.claimInSolution")}
          </Radio.Button>
          <Radio.Button value={"solved"}>
            {t("cleanings.claimSolved")}
          </Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name={"is_claim_in_solution"}
        initialValue={cleaning?.is_claim_in_solution}
        hidden
        valuePropName={"checked"}
      >
        <Checkbox />
      </Form.Item>
      <Form.Item
        name={"is_claim_solved"}
        initialValue={cleaning?.is_claim_solved}
        hidden
        valuePropName={"checked"}
      >
        <Checkbox />
      </Form.Item>
    </React.Fragment>
  );
};

export default CleaningClaimStatusSelect;
